import React, { useState } from "react";
import { CircularProgress, Fab, TextField, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  selectAircraftById,
  selectAircraftConnectionById,
} from "../../features/aircraft/aircraftSelectors";
import { AircraftNub } from "./AircraftNub";
import { ReactComponent as Add } from "../../assets/svg/Plus.svg";
import { ReactComponent as Minus } from "../../assets/svg/Actions-Minus.svg";
import { connectThunk } from "../../features/aircraft/aircraftActions";
import { restartUavConnection } from "../../features/aircraft/aircraftSlice";
import { Sim } from "../../features/aircraft/types";
import { Logger } from "../../tools/Logger";

export const SelectAircraftItem = (props: {
  uavId: string;
  sims?: Sim[];
  port?: string;
}) => {
  const [uavIdText, setUavIdText] = useState<string>("");
  const connection = useAppSelector((state) =>
    selectAircraftConnectionById(state, uavIdText || props.uavId)
  );
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const live = useAppSelector((state) =>
    selectAircraftById(state, uavIdText || props.uavId)
  );
  const [connectingToCraft, setConnectingToCraft] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const handleUavIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUavIdText(event.target.value);
  };

  const onClick = async () => {
    setError(null);
    if (connection) {
      dispatch(restartUavConnection({ uavId: uavIdText || props.uavId }));
    } else {
      setConnectingToCraft(true);
      const thunk = dispatch(
        connectThunk({
          sims: props.sims ? props.sims : live?.sims,
          uavId: uavIdText || props.uavId,
          port: props.port || "",
        })
      );
      try {
        await thunk.unwrap();
        setConnectingToCraft(false);
      } catch (err) {
        setConnectingToCraft(false);
        Logger.error("SelectAircraftItem", err);
        setError(err);
      }
    }
  };
  return (
    <Box display={"flex"} justifyContent="space-between">
      <Box display={"flex"} flexDirection={"row"}>
        <Box display="flex" width={54}>
          {props.uavId === "" ? (
              <TextField
                InputProps={{
                  style: { height: "40px", width: "54px", fontSize: 12 },
                }}
                sx={{
                  height: "40px",
                  width: "79px",
                  boxSizing: "border-box",
                  borderRadius: 2,
                  borderColor: "text.primary",
                  backgroundColor: connection?.connected
                    ? "background.paper"
                    : "other.disabledBackground",
                }}
                value={uavIdText}
                onChange={handleUavIdChange}
              ></TextField>
            ) : (
              <AircraftNub
                uavId={props.uavId}
                connected={connection?.connected}
              />
            )}
        </Box>
        <Box display={"flex"} pl={2} flexDirection={"column"} minHeight={56}>
          <Box display={"flex"} alignItems={"center"}>
            <Typography variant={"h6"} color={theme.palette.text.primary}>
              {connection ? `Added` : `Not Added`}
            </Typography>
          </Box>
          <Box display={"flex"}>
            <Typography
              variant={"subtitle2"}
              fontSize={14}
              color={theme.palette.error.main}
              align="left"
            >
              {error?.message}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box display={"flex"}>
        <Fab
          sx={{
            width: 40,
            height: 40,
            boxShadow: "none",
            backgroundColor: connection
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
            border: `${connection ? 2 : 1}px solid ${
              connection
                ? theme.palette.text.primary
                : theme.palette.text.secondary
            }`,
          }}
          aria-label={"fab"}
          disabled={connectingToCraft}
          onClick={onClick}
        >
          {connectingToCraft ? (
            <CircularProgress size={16} style={{ color: "white" }} />
          ) : connection ? (
            <Minus stroke={theme.palette.text.primary} />
          ) : (
            <Add stroke={theme.palette.text.secondary} />
          )}
        </Fab>
      </Box>
    </Box>
  );
};
